const IslandModel = {
    id: "",
    name: "",
    description: "",
    full_address: "",
    counter: 0,
    lat: 0,
    lng: 0,
    coords: [],
    actives: [],
    image: {
        url: null,
        dated: null,
        camera: null,
    },
    zone_id: "",
};

export default IslandModel;
